<mat-card class="desktop-attendance attendance-table-card table-surface-card">
  <mat-card-content>
    <app-table-toolbar
    title="Concurrencia"
    titleIcon="groups"
    titleInfoTooltip="Información sobre el listado"
    [columns]="tableColumns"
    [activeFilters]="activeFilters"
    [density]="tableDensity"
    [tableId]="tableId"
    [enableSearch]="true"
    searchPlaceholder="Buscar miembro"
    [enableFilter]="true"
    [enableSort]="true"
    [sortState]="sortState"
    [enableColumnVisibility]="true"
    [enableDensity]="true"
    (searchChange)="onDesktopSearch($event)"
    (filterRemove)="onFilterRemove($event)"
    (sortChange)="onSortChange($event)"
    (columnVisibilityChange)="onColumnVisibilityChange($event)"
    (densityChange)="onDensityChange($event)"
    (titleInfoClick)="showRosterInformation()">
    <div filterPanel class="attendance-filter-panel" [formGroup]="desktopFilterForm">
      <app-data-table-multi-select-filter formControlName="minor" label="Edad" [options]="minorFilterOptions"></app-data-table-multi-select-filter>
      <app-data-table-multi-select-filter formControlName="sealed" label="Sellado" [options]="sealedFilterOptions"></app-data-table-multi-select-filter>
      <app-data-table-multi-select-filter formControlName="visitor" label="Visita" [options]="visitorFilterOptions"></app-data-table-multi-select-filter>
      <app-data-table-multi-select-filter formControlName="attended" label="Asistencia" [options]="attendedFilterOptions"></app-data-table-multi-select-filter>

    </div>
    </app-table-toolbar>

    <app-data-table
    [columns]="tableColumns"
    [data]="desktopPageMembers"
    [isLoading]="isLoading"
    [errorMessage]="errorMessage"
    [cellTemplate]="attendanceCell"
    [tableId]="tableId"
    [density]="tableDensity"
    [initialSort]="sortState"
    [paginationConfig]="paginationConfig"
    [showPageSizeSelector]="true"
    [pageSizeOptions]="[10, 25, 50, 100]"
    tableHeight="55vh"
    noDataMessage="No hay miembros que coincidan con los filtros"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)">
    </app-data-table>

    <ng-template #attendanceCell let-column="column" let-member="row">
    <ng-container [ngSwitch]="column">
      <span *ngSwitchCase="'name'" class="desktop-member-name">
        <app-member-reference
          [personId]="member.personId"
          [name]="getFullName(member)"
          [stopPropagation]="true">
        </app-member-reference>
        <mat-icon *ngIf="isVisitor(member)" class="desktop-visitor-icon" matTooltip="Visita">person_pin</mat-icon>
      </span>
      <span *ngSwitchCase="'age'">{{ isMinor(member) ? 'Menor' : 'Mayor' }}</span>
      <span *ngSwitchCase="'sealed'">{{ member.isSealed ? 'Sí' : 'No' }}</span>
      <span *ngSwitchCase="'visitor'">{{ isVisitor(member) ? 'Sí' : 'No' }}</span>
      <span *ngSwitchCase="'attended'" class="attendance-cell">
        <mat-spinner *ngIf="isToggling(member.personId); else desktopAttendanceCheckbox" diameter="18"></mat-spinner>
        <ng-template #desktopAttendanceCheckbox>
          <mat-checkbox
            [checked]="isMemberAttending(member.personId)"
            (change)="onAttendanceChange(member, $event.checked)"
            [disabled]="readonly || isSaving"
            [attr.aria-label]="'Asistencia de ' + getFullName(member)">
          </mat-checkbox>
        </ng-template>
      </span>
    </ng-container>
    </ng-template>
  </mat-card-content>
</mat-card>

<!-- Filter and Actions -->
<div class="filter-section mobile-attendance" [class.disabled]="isLoading">
  <div class="mobile-search-row">
    <mat-form-field class="search-field" appearance="fill" subscriptSizing="dynamic">
      <mat-label>Buscar Miembro</mat-label>
      <input matInput [formControl]="searchControl">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <button
      mat-icon-button
      type="button"
      class="roster-info-button"
      aria-label="Información sobre el listado"
      matTooltip="Información sobre el listado"
      (click)="showRosterInformation()">
      <mat-icon>info_outline</mat-icon>
    </button>
  </div>

</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container mobile-attendance">
  <mat-spinner diameter="40"></mat-spinner>
  <p>Cargando miembros...</p>
</div>

<!-- Error Message -->
<mat-error *ngIf="errorMessage" class="error-message mobile-attendance">
  {{ errorMessage }}
</mat-error>

<div class="members-list mobile-attendance" *ngIf="!isLoading">
  <mat-list>
    <mat-list-item *ngFor="let member of filteredMembers" class="member-item"
      [class.attended]="isMemberAttending(member.personId)">
      <div matListItemTitle class="member-info">
        <span class="member-name">
          <app-member-reference
            [personId]="member.personId"
            [name]="getFullName(member)"
            [stopPropagation]="true">
          </app-member-reference>
          <span class="member-indicators">
            <span *ngIf="member.isVisitor || member.attendanceCategory === 'Visitor'" class="visitor-badge">Visita</span>
            <span *ngIf="!member.isSealed" class="classification-badge unsealed">No sellado</span>
            <mat-icon *ngIf="isMinor(member)" class="minor-icon" matTooltip="Menor">child_care</mat-icon>
          </span>
        </span>
      </div>

      <div matListItemMeta class="attendance-control">
        <mat-spinner *ngIf="isToggling(member.personId); else attendanceCheckbox" diameter="24"
          class="toggle-spinner"></mat-spinner>
        <ng-template #attendanceCheckbox>
          <mat-checkbox [checked]="isMemberAttending(member.personId)"
            (change)="onAttendanceChange(member, $event.checked)" [disabled]="readonly || isSaving"
            [attr.aria-label]="'Asistencia de ' + getFullName(member)"
            class="attendance-checkbox">
          </mat-checkbox>
        </ng-template>
      </div>
    </mat-list-item>

    <!-- Empty State -->
    <app-empty-state *ngIf="filteredMembers.length === 0" icon="search_off" title="Sin resultados"
      description="No hay miembros que coincidan con tu búsqueda">
    </app-empty-state>
  </mat-list>
</div>
